/*
 * @Description: 别的页面跳转过来， navigate(`user/payment/success?orderId=${orderId}&payWay=${res.obj.payMethod}`)
 * @Author: ywj
 * @Date: 2025-03-07 09:32:44
 * @LastEditTime: 2026-05-09 09:25:53
 * @LastEditors: taoyuan taoyuan@originqc.com
 */
import React, { useState, useEffect } from 'react';
import Header from '../../components/header';
import OrderCard from '../components/order-card';
import LikeCarousel from '@/components/like-carousel';
import { getOrderById } from '@/api/personal-center';

import './index.scss';
import { message } from 'antd';
import { useSearchParams, useNavigate } from 'react-router-dom';

interface IOrderData {
  totalAmount: string;
  qrcodeUrl: string;
  orderName: string;
  orderNo: string;
  payAmount: string;
  restTime: string;
  id: number;
  receiver: {
    id: number;
    name: string;
    tel: string;
    city: string;
    province: string;
    region: string;
    detailAddress: string;
  };
  billBase: {
    type: number;
    id: number;
    name: string;
    header: string;
  };
}

const PaymentSuccess: React.FC = () => {
  const [orderData, setOrderData] = useState<IOrderData>();
  const [searchParams] = useSearchParams();
  // 获取 订单id 参数
  const orderId = searchParams.get('orderId');
  const payWayUrl = searchParams.get('payWay') ?? '';
  const navigate = useNavigate();
  useEffect(() => {
    getOrderById({ id: orderId }).then((res: any) => {
      if (res.success) {
        setOrderData(res.obj);
      } else {
        message.error(res.message);
      }
    });
  }, []);

  const goHome = () => {
    navigate('/home');
  };

  return (
    <div>
      <Header title='收银台' />
      <div className='payment-container'>
        <OrderCard
          orderData={orderData || ({} as IOrderData)}
          type='paid'
          payWays={Number(payWayUrl)}
        />
        <div className='scan-box'>
          <div className='box-btns'>
            <div className='back-home-btn' onClick={goHome}>
              返回首页
            </div>
            <div className='back-order-btn' onClick={()=>navigate(`/user/order/detail/${orderData?.id}`)}>
              {(orderData as any)?.productList?.[0]?.productType === 3
                ? '查看订单（前往下载SDK）'
                : '查看订单'}
            </div>
          </div>

          <LikeCarousel />
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
